import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object({
  narration: yup.string().required("Narration is required"),
  entry_date: yup.string().required("Entry date is required"),
  tax_type: yup.string().required("Tax type is required"),
  store_id: yup.string().required("Store is required"),
  lines: yup
    .array()
    .of(
      yup.object({
        chart_account_id: yup.string().required("Account is required"),
        description: yup.string().required("Description is required"),
        debit_amount: yup
          .number()
          .typeError("Debit amount must be a number")
          .min(0, "Debit amount cannot be negative")
          .nullable()
          .transform((value, originalValue) =>
            originalValue === "" ? null : value,
          )
          .test(
            "debit-credit-exclusive",
            "Either debit amount or credit amount must be greater than 0, but not both",
            function (value) {
              const { credit_amount } = this.parent;
              const debit = value || 0;
              const credit = credit_amount || 0;
              if ((debit > 0 && credit > 0) || (debit === 0 && credit === 0)) {
                return false;
              }
              return true;
            },
          ),
        credit_amount: yup
          .number()
          .typeError("Credit amount must be a number")
          .min(0, "Credit amount cannot be negative")
          .nullable()
          .transform((value, originalValue) =>
            originalValue === "" ? null : value,
          )
          .test(
            "debit-credit-exclusive",
            "Either credit amount or debit amount must be greater than 0, but not both",
            function (value) {
              const { debit_amount } = this.parent;
              const credit = value || 0;
              const debit = debit_amount || 0;
              if ((credit > 0 && debit > 0) || (credit === 0 && debit === 0)) {
                return false;
              }
              return true;
            },
          ),
        tax_rate: yup
          .number()
          .typeError("Tax rate must be a number")
          .min(0, "Tax rate cannot be negative")
          .max(100, "Tax rate cannot be greater than 100"),
      }),
    )
    .min(2, "At least two journal lines are required"),
});

const Validation = ({ journalEntryDetails }) => {
  return useForm({
    resolver: yupResolver(schema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      ...journalEntryDetails,
    },
  });
};

export default Validation;
